<template>
  <input
    :type="type"
    :readonly="cReadonly"
    :value="value"
    @input="change($event)"
  />
</template>

<script>
import { ControlValueAction } from './history'

export default {
  props: ['emitter', 'ikey', 'readonly', 'type', 'getData', 'putData'],

  data() {
    return {
      value: 0,
      preview: false,
    }
  },

  computed: {
    cReadonly() {
      if (this.preview) {
        return true
      } else {
        return this.readonly
      }
    },
  },

  methods: {
    change(e) {
      if (this.value !== e.target.value) {
        const editor = this.emitter
        const action = new ControlValueAction(
          editor,
          this._uid,
          this.value,
          e.target.value,
          'input'
        )

        editor.trigger('addvaluehistory', action)
        this.write(e.target.value)
      }
    },

    write(val) {
      this.value = val
      this.putData(this.ikey, this.value)
    },
  },

  mounted() {
    this.value = this.getData(this.ikey)

    if (this.readonly) {
      this.$el.style.cursor = 'pointer'
    } else {
      this.$el.addEventListener('pointerdown', (e) => e.stopPropagation())
      this.$el.addEventListener('mousewheel', (e) => e.stopPropagation())
      this.$el.addEventListener('dblclick', (e) => e.stopPropagation())
    }
  },
}
</script>
